import React from 'react'
import {useSelector} from 'react-redux'
import {cx} from '@emotion/css'
import styled from '@emotion/styled'
import {useGetRoomLabels} from 'components/Offer/hooks/useGetRoomLabels'
import {getOfferHasGhaOrGvrPreferredRate} from 'modules/sapiSearch/selectors'
import {SearchOffer} from 'modules/sapiSearch/slice'
import {getShouldShowYourChoiceTag} from 'modules/search/selectors'
import {equals, last} from 'ramda'

import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'

export interface Props {
  /** Whether to render the labels in the alternative color  */
  isAlternativeColor?: boolean
  /** Offer state */
  offer: SearchOffer
}

const RoomLabelsText = styled(Text)`
  color: ${cssTheme.colors.content.success.secondary};
  &.--is-alternative-color {
    color: ${cssTheme.colors.content.neutral.secondary};
  }
  &.--has-first-green {
    span:first-of-type {
      color: ${cssTheme.colors.content.success.secondary};
    }
  }
`

const RoomLabelsItem = styled.span`
  display: inline-block;
  margin-right: ${cssTheme.layout.spacing.s200};
`

const Dot = styled(RoomLabelsText)`
  display: inline-block;
  margin-left: ${cssTheme.layout.spacing.s200};
`

export const RoomLabels = ({offer, isAlternativeColor = false}: Props) => {
  const shouldShowFreeCancellationDate = useSelector(state =>
    getOfferHasGhaOrGvrPreferredRate(state, offer)
  )

  const shouldShowYourChoice = useSelector(getShouldShowYourChoiceTag(offer))

  const translatedLabels = useGetRoomLabels({
    offer,
    shouldShowFreeCancellationDate
  })

  if (translatedLabels.length <= 0) return null

  return (
    <RoomLabelsText
      variant="bodyXS"
      dataId="RoomLabels"
      className={cx(
        '--container-rooms-label',
        isAlternativeColor && '--is-alternative-color',
        shouldShowYourChoice && '--has-first-green'
      )}
    >
      {translatedLabels.map(label => (
        <RoomLabelsItem key={label}>
          {label}
          {!equals(last(translatedLabels), label) && (
            <Dot
              variant="bodyXS"
              as="span"
              className={cx(isAlternativeColor && '--is-alternative-color')}
            >
              ·
            </Dot>
          )}
        </RoomLabelsItem>
      ))}
    </RoomLabelsText>
  )
}
